// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"679840c3","239":"8df65e18","367":"086c12e2","453":"5df5becb","732":"99fb4511","977":"e867f4ba"}[chunkId] + ".chunk.js";
};